import React, { useState } from "react";
import Icon from "../Icon";
import { FEATURE_DIVE_ITEMS } from "../landingData";
import FeatureDeepDiveVisual from "./FeatureDeepDiveVisual";

const FeatureDeepDive = () => {
    const [activeUid, setActiveUid] = useState(FEATURE_DIVE_ITEMS[0].uid);
    const activeFeature =
        FEATURE_DIVE_ITEMS.find((item) => item.uid === activeUid) ?? FEATURE_DIVE_ITEMS[0];

    return (
        <div className="clk-feature-dive">
            <div className="clk-fcat-panel clk-reveal">
                <div className="clk-fcat-showcase">
                    <nav className="clk-fcat-feature-nav" aria-label="Features">
                        {FEATURE_DIVE_ITEMS.map((feature) => (
                            <button
                                key={feature.uid}
                                type="button"
                                className={`clk-fcat-feature-btn${
                                    activeUid === feature.uid ? " is-active" : ""
                                }`}
                                onClick={() => setActiveUid(feature.uid)}
                            >
                                <span className="clk-fcat-feature-ic" aria-hidden="true">
                                    <Icon name={feature.icon} size={18} />
                                </span>
                                <span className="clk-fcat-feature-label">{feature.title}</span>
                            </button>
                        ))}
                    </nav>

                    <div key={activeFeature.uid} className="clk-fcat-detail" aria-live="polite">
                        <div className="clk-fcat-detail-inner">
                            <div className="clk-fcat-detail-copy">
                                <span className="clk-fcat-detail-tag">{activeFeature.tag}</span>
                                <h3 className="clk-fcat-detail-title">{activeFeature.title}</h3>
                                <p className="clk-fcat-detail-desc">{activeFeature.description}</p>
                                <ul className="clk-check-list clk-fcat-detail-checks">
                                    {activeFeature.points.map((point, index) => (
                                        <li
                                            key={point}
                                            style={{ "--clk-fcat-check-i": index }}
                                        >
                                            {point}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <FeatureDeepDiveVisual type={activeFeature.visual} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeatureDeepDive;
